import {
  SET_CURRENT_USER,
  USER_LOADING,
  SET_BUDGETS,
  GET_USER_INFO,
  SET_SPEND_RANGE_DAYS_SELECTED,
  SET_CURRENT_ON_BEHALF_USER
} from "../actions/types";
import { AUTH_MOCK_DATA } from "./reduxMockData";

const isLiveData = process.env.REACT_APP_LIVEDATA === "true";

const isEmpty = require("is-empty");
const moment = require("moment");

// Try loading some demo/example data
const initialState = AUTH_MOCK_DATA;
initialState.currentMonthName = moment().format("MMMM");
if (isLiveData) {
  initialState.user = { preferredName: "" };
  initialState.loading = false;
  initialState.budgets = {};
  initialState.expenseBudgetSum = 0;
  initialState.spendRangeDays = 30;
  initialState.perTransactionSettings = {};
  initialState.currentOnBehalfUser = { _id: "", email: "" };
}
initialState.user.givePermToActAsMe = [];
initialState.user.allowedToActAs = {};
//If we decide to do a scramble mode
//initialState.scrambleMode = 0;

// Below here is the normal initial state
/*const initialState = {
  user: { preferredName: "" },
  loading: false,
  budgets: {},
  expenseBudgetSum: 0,
  spendRangeDays: 30,
  perTransactionSettings: {},
};*/

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_ON_BEHALF_USER:
      return {
        ...state,
        currentOnBehalfUser: action.payload,
      };
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        user: action.payload,
      };
    case USER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SET_BUDGETS:
      return {
        ...state,
        budgets: action.payload.allBudgets,
        expenseBudgetSum: action.payload.expenseBudgetSum,
      };
    case GET_USER_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case SET_SPEND_RANGE_DAYS_SELECTED:
      return {
        ...state,
        spendRangeDays: action.payload,
      };
    default:
      return state;
  }
}
